<template>
  <el-dialog
    :id="$options.name"
    :before-close="noDialog"
    :fullscreen="dialogFullscreen"
    :visible.sync="dialog"
    title="远程开门"
    @close="handleClose"
  >
    <div class="door_wrapper">
      <div
        class="door_item"
        :class="{ door_item_active: activeIndex == index }"
        v-for="(item, index) in doorList"
        :key="item.id"
        @click="handleDoorItemClick(index)"
      >
        <div class="item_text">
          门禁编号:
          {{
            item.accessControlDeviceQrCode && item.accessControlDeviceQrCode.id
          }}
        </div>
        <div class="item_text">硬件UID: {{ item.ids }}</div>
        <div class="item_text">
          网络状态: {{ item.onLine ? "在线" : "离线" }}
        </div>
      </div>
    </div>
    <div slot="footer">
      <el-button @click="noDialog">取 消</el-button>
      <el-button type="primary" @click="open">开门</el-button>
    </div>
  </el-dialog>
</template>

<script>
import CarPort from "@/maintain/api/device/CarPort";
import maintainRemoteDoorOpen from "@/maintain/api/device/access-control-device-controler/maintainRemoteDoorOpen";

import dialogMixin from "@/mixin/dialogMixin";
import resDisposeMixin from "@/mixin/resDisposeMixin";
import { Message } from "element-ui";

export default {
  name: "openDoorDialog",
  mixins: [dialogMixin, resDisposeMixin],
  props: {
    openDoorDialogObj: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      doorList: [],
      activeIndex: -1,
    };
  },
  watch: {
    openDoorDialogObj(newV) {
      if (!newV) return;

      CarPort.maintainGetCarportById({ carportId: newV.id }).then((res) => {
        this.doorList = res.data.accessControlDeviceList || [];
        this.activeIndex = this.doorList.findIndex((d) => d.onLine);
      });

      // this.doorList = newV.accessControlDeviceList || [];
      // this.activeIndex = this.doorList.findIndex((d) => d.onLine);
    },
  },
  methods: {
    open() {
      if (this.activeIndex < 0) {
        return Message.error("请先选择一个在线的门禁设备~");
      }
      maintainRemoteDoorOpen(this.doorList[this.activeIndex].ids).then((res) => {
        if (res.code == 1) {
          Message.success("操作成功~");
        }
      });
    },
    handleDoorItemClick(index) {
      if (!this.doorList[index].onLine) {
        return Message.error("设备已离线~");
      }
      this.activeIndex = index;
    },
    handleClose() {
      this.$emit("close");
      this.activeIndex = -1;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/styles/my";

@include mobile {
  .door_item {
    width: calc(50% - 20px) !important;
  }
}
.door_wrapper {
  display: flex;

  .door_item {
    position: relative;
    margin: 0 10px;
    width: calc(25% - 20px);
    border: 3px solid #aaa;
    border-radius: 15px;
    height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #aaa;
    cursor: pointer;

    .item_text {
      margin: 5px 0;
      font-size: 16px;
      font-weight: bold;
    }

    // &::after {
    //   display: block;
    //   content: "";
    //   width: 3px;
    //   height: 35px;
    //   background: #aaa;
    //   border-radius: 10px;
    //   position: absolute;
    //   top: 50%;
    //   right: 10px;
    //   transform: translateY(-50%);
    // }
  }

  .door_item_active {
    color: #f47a00;
    border-color: #ff8000;

    // &::after {
    //   background: #ff8000;
    // }
  }
}
</style>
